import { GlobalState } from '@leverege/ui-redux';
import { Auth } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import LinkAction from "../../../routes/LinkAction.js";
const {
  t,
  tf,
  tfIcon
} = I18N.ns('molten.screens.settings');
export default LinkAction.create({
  id: 'link.mobile.Settings',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  path: '/settings',
  startsWith: true,
  layout: {
    group: ['user'],
    groupIcons: [tfIcon('profileMenuIcon')],
    groupNames: [() => {
      return GlobalState.get().auth?.profile?.name || Auth.getUsername(GlobalState.get().auth) || t('groupName');
    }],
    sort: 'b'
  },
  handles: context => {
    return context.mobile;
  },
  name: tf('name'),
  icon: tfIcon('accountIcon')
});